<template>
  <div>
    <div v-for="(item, index) in row?.termInfoList" :key="index">
      <span v-if="!item.remark" style="word-break: break-word">
        {{ index + 1 + '.' + item.srcText }}
      </span>
      <el-tooltip class="item" effect="dark" :content="item.remark">
        <span v-show="item.remark" style="word-break: break-word">
          {{ index + 1 + '.' + item.srcText }}
        </span>
      </el-tooltip>
      <br />
      <span
        style="word-break: break-word"
        :class="[
          row?.qcStatus != -1 &&
          row?.peTextShowOld &&
          jsonTextToText(row?.peTextShowOld)
            .toLowerCase()
            .indexOf((item?.tranText).toLowerCase()) == -1
            ? 'c-red'
            : '',
        ]"
      >
        <el-tooltip
          class="item"
          effect="dark"
          content="检测到译文中未使用该术语，请仔细检查译文哦！"
        >
          <i
            class="el-icon-warning c-red"
            v-show="
              row?.qcStatus != -1 &&
              row?.peTextShowOld &&
              jsonTextToText(row?.peTextShowOld)
                .toLowerCase()
                .indexOf((item?.tranText).toLowerCase()) == -1
            "
          ></i>
        </el-tooltip>
        {{ item.tranText }}
      </span>
    </div>
  </div>
</template>

<script>
import { jsonTextToText } from '@/components/rich-text';
export default {
  name: 'TermListColumn',
  props: ['row', 'currentRow'],
  methods: {
    jsonTextToText,
  },
};
</script>
